<script setup>
import {ref} from "vue";
import createTenantPhotography from './components/createTenantPhotography/index.vue';
import router from "@/router/index.js";
import {addPhotographyIgnore} from "@/api/photography/ignoreTenant.js";

// 加载状态
const loading = ref(false)
/*基本信息相关*/
// 基本信息表单
const ruleForm = ref({
  storeLogo: null,
  name: null,
  nameEn: "Coming Soon ...",
  certificationType: null,
  storeAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null
  },
  tenantId: null,
  // 营业时间
  operatingHours: [{
    operatingTime: [],
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null
  }],
  serviceCities: [],
  referralOfficer: {
    name: null,
    phone: null
  },
  nonSelfOperatedLink: null,
  serviceModeTypes: [],
  summary: null,
  summaryEn: null,
  description: null,
  descriptionEn: null,
  // 负责人信息
  contactName: null,
  phone: null,
  contactEmail: null,
  recipientInfo: {
    recipientName: null,
    recipientPhone: null,
    recipientAddress: {
      provinceCode: null,
      cityCode: null,
      districtCode: null,
      addressDetail: null
    }
  },
  assistsOperation: true
})
// 处理表单提交新建俱乐部
const handleCreateTenantPhotography = async () => {
  try {
    loading.value = true
    await addPhotographyIgnore(ruleForm.value)
    router.push({ path: "/listTenantPhotography" })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <div v-loading="loading" style="height: 100%">
    <createTenantPhotography v-model="ruleForm" @success="handleCreateTenantPhotography"></createTenantPhotography>
  </div>
</template>

<style scoped>

</style>
